// BaseScreens
import FilterViewer from 'components/ContactFilterBuilder/Views/FilterViewer'
import OperatorAndValue from 'components/ContactFilterBuilder/Views/OperatorAndValue'
import SetName from 'components/ContactFilterBuilder/Views/SetName'
// ListViews
import ContactPropertiesList from 'components/ContactFilterBuilder/PropertyLists/ContactProperties'
import PlaybookEventList from 'components/ContactFilterBuilder/PropertyLists/PlaybookEvents'
import ContactTagsList from 'components/ContactFilterBuilder/PropertyLists/ContactTags'
import ContactEventsList from 'components/ContactFilterBuilder/PropertyLists/ContactEvents'
import PlaybookSelection from 'components/ContactFilterBuilder/PropertyLists/PlaybookSelection'
// Dates
import DateRangeCreation from 'components/ContactFilterBuilder/Views/DateRange'

export const ViewMaps = {
  'PBSelection': PlaybookSelection,
  'PBEvents': PlaybookEventList,
  'Properties': ContactPropertiesList,
  'Tags': ContactTagsList,
  'Events': ContactEventsList,
  'Range': DateRangeCreation,
  'Filter': FilterViewer,
  'Operator': OperatorAndValue,
  'SetName': SetName
}

export const ViewHeadings = {
  'Selection': 'Create filter',
  'PBEvents': 'Choose playbook event',
  'PBSelection': 'Choose a playbook',
  'Properties': 'Choose contact attribute',
  'Tags': 'Choose contact tag',
  'Events': 'Choose a stream event',
  'Range': 'Choose a date range',
  'Filter': 'Filter by',
  'Operator': 'Choose an operator',
  'SetName': 'Choose a name and type'
}
